var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhyChooseSimplifiedApiAutomationMinimalCodeAutomationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.97 40.8L47.97 55.8C47.835 56.52 47.205 57 46.5 57C46.395 57 46.305 57 46.2 56.97C45.39 56.805 44.865 56.01 45.03 55.2L48.03 40.2C48.195 39.39 48.975 38.865 49.8 39.03C50.61 39.195 51.135 39.99 50.97 40.8ZM41.565 40.95C40.98 40.365 40.035 40.365 39.45 40.95L34.515 45.885C33.345 47.055 33.345 48.96 34.515 50.13L39.45 55.065C39.75 55.365 40.125 55.5 40.515 55.5C40.905 55.5 41.28 55.35 41.58 55.065C42.165 54.48 42.165 53.535 41.58 52.95L36.645 48.015L41.58 43.08C42.165 42.495 42.165 41.55 41.58 40.965L41.565 40.95ZM69 31.5V64.5C69 66.975 66.975 69 64.5 69H31.5C29.025 69 27 66.975 27 64.5V31.5C27 29.025 29.025 27 31.5 27H64.5C66.975 27 69 29.025 69 31.5ZM66 31.5C66 30.675 65.325 30 64.5 30H31.5C30.675 30 30 30.675 30 31.5V64.5C30 65.325 30.675 66 31.5 66H64.5C65.325 66 66 65.325 66 64.5V31.5ZM56.565 40.935C55.98 40.35 55.035 40.35 54.45 40.935C53.865 41.52 53.865 42.465 54.45 43.05L59.385 47.985L54.45 52.92C53.865 53.505 53.865 54.45 54.45 55.035C54.75 55.335 55.125 55.47 55.515 55.47C55.905 55.47 56.28 55.32 56.58 55.035L61.515 50.1C62.685 48.93 62.685 47.025 61.515 45.855L56.58 40.92L56.565 40.935Z",
    fill: "#307A64",
    stroke: "#307A64",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyChooseSimplifiedApiAutomationMinimalCodeAutomationIcon);
export default __webpack_public_path__ + "static/media/whyChooseSimplifiedApiAutomationMinimalCodeAutomationIcon.4cc3c172e08cb5c23fbbe448a3b7fbc4.svg";
export { ForwardRef as ReactComponent };